import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import {Grid, withWidth} from "@material-ui/core";
import {} from "@material-ui/icons";
import {Fade} from 'react-reveal';

const playStore = '/images/icons/social/play-badge.svg';
const appStore = '/images/icons/social/app-store.svg';

const styles = theme => ({
  root: {
    padding: theme.spacing.unit * 8,
    background: theme.palette.primary.light,
  },
  icon: {
    width: 200,
    margin: theme.spacing.unit * 3,
  }
});

const ApplicationLinks = withStyles(styles)(({classes}) => (
  <div className={classes.root}>
    <Grid container justify="center" alignItems="center">
      <Grid item xs={12} sm={6} md={3}>
        <Fade left duration={1500} distance="100px">
          <Grid container direction="column" alignItems="center">
            <Grid item>
              <img src={playStore} alt="Android app" className={classes.icon}/>
            </Grid>
          </Grid>
        </Fade>
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <Fade right duration={1500} distance="100px">
          <Grid container direction="column" alignItems="center">
            <Grid item>
              <img src={appStore} alt="Android app" className={classes.icon}/>
            </Grid>
          </Grid>
        </Fade>
      </Grid>
    </Grid>
  </div>
));

export default withWidth()(ApplicationLinks);
